export default __webpack_public_path__ + "153f7d49089ef50420cd87d2043448df.woff";